import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import './App.css';
import { SignIn, SignUp } from '@clerk/clerk-react';
import ProfilePage from "./components/user/ProfilePage.js";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import RealTimePage from "./pages/RealTimePage";
import NavBar from "./components/NavBar";
import { ThemeProvider } from './components/theme/ThemeContext';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

function ProtectedRoute({ children }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut><RedirectToSignIn /></SignedOut>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <div className="App" id="app">
        <header>
          <NavBar />
        </header>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='*' element={<Navigate to='/' />} />
            <Route
              path="/login"
              element={
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
                  <SignIn routing="hash" />
                </Box>
              }
            />
            <Route
              path="/register"
              element={
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
                  <SignUp routing="hash" />
                </Box>
              }
            />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
<Route path="/realtime" element={<RealTimePage />} />
          </Routes>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
